<div class="page-title">
  <div class="row align-items-center justify-content-between">
    <div class="col-auto">{{_appService?.CoreCommonLiterals?.EndpointsWord}}</div>
    <div class="col-1">
      <button id="devices-btn-collapsed" type="button" class="btn btn-primary float-right" tooltip="{{_appService.CoreCommonLiterals?.Filter}}" (click)="sidebar.open()" aria-controls="filters">
        <i class="fa fa-filter"></i>
      </button>
    </div>
  </div>
</div>

<lib-sidebar #sidebar id="filters" [title]="_appService.CoreCommonLiterals?.Filter" [invisibleBackdrop]="true">
  <form autocomplete="off">
    <div class="form-group">
      <form-parameters #formParam [context]="this" [formParameterList]="formParameterList" (formParameterChange)="emitChangeParam($event)" [ngClass]="{'disabled-form': !enableFilter}"></form-parameters>
      <div class="text-right mt-5">
        <button (click)="applyFiltersDevice('apply');sidebar.close()" type="submit" id="btn-applyfilters" class="btn btn-primary btn-block mt-3">
          {{_appService.CoreCommonLiterals?.Apply}}
        </button>
      </div>
    </div>
  </form>
</lib-sidebar>

<div class="screen-container">
  <div class="row mt-2 mb-3">
    <div class="col-12">
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          [(ngModel)]="_filter"
          (input)="onFilterInput()"
          [disabled]="loading"
          placeholder="{{_appService.CoreCommonLiterals?.ButtonSearch}}..."
        />
        <div class="input-group-append" *ngIf="_filter">
          <button class="btn btn-secondary" type="button" (click)="clearFilter()" style="margin-left: 2px;">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-accordion>
    <div *ngFor="let c of filteredClusters;let i= index;" >
      <app-panel [title]="c.Description" id="{{i}}" [opened]="openCollapse">
        <app-table [data]="c" (openActions)="openDropdown($event)" [actions]="actions"></app-table>
      </app-panel>
    </div>

    <div dropdown #dropdown="bs-dropdown" style="position: absolute; z-index: 5;" [autoClose]="true" [ngStyle]="{'top': _dropdownConfig.y + 'px', 'left': _dropdownConfig.x + 'px'}" class="dropdown">
      <app-drop-item
        *dropdownMenu
        [actions]="actions"
        class="dropdown-menu dropdown-menu-right">
      </app-drop-item>
    </div>
  </app-accordion>
  <div *ngIf="isSearching" class="text-center my-3 not-found-message">
    <div class="text-muted small flex-column">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
      <div class="loading-spinner-text mt-2">{{_appService.CoreCommonLiterals?.Loading}}</div>
    </div>
  </div>
  
  <div *ngIf="!isSearching && loading" class="text-center my-3 not-found-message">
    <div class="text-muted small flex-column">
      <i class="fas fa-circle-notch fa-spin fa-2x"></i>
      <div class="loading-spinner-text mt-2">{{_appService.CoreCommonLiterals?.Loading}}</div>
    </div>
  </div>
  
  <div *ngIf="!isSearching && showTailSpinner && showIcon !== 0 && filteredClusters.length > 0" class="text-center my-4">
    <div class="text-muted small">
      <span class="spinner-border spinner-border-sm text-primary mr-2" role="status"></span>
      {{_appService.CoreCommonLiterals?.DeviceLoading}}...
    </div>
  </div>
</div>
<div *ngIf="!isSearching && !filteredClusters.length && !loading && showIcon !== 0" class="not-found-message text-center mt-5">
  <i class="fa fa-file-alt fa-5x text-primary"></i>
  <p class="h4 mt-3">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
</div>